import './Song.css';
import { Link } from 'react-router-dom';

function Song2(props) {
  return (
    <div className="Containar">
        <Link to={props.songLink}><img src={props.img} className='CoverImage' height={256} width={256}/></Link>
        <div>
          <p className='Name'><Link to={props.songLink}>{props.name}</Link></p>
          <p className='artist'>
            <Link to={props.artist1Link}>{props.artist1}</Link>, <Link to={props.artist2Link}>{props.artist2}</Link>
          </p>
        </div>
    </div>
  );
}

export default Song2;